import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getDate, replace } from '../../../utils/func';
import Status from './Status/Status';
import OrdersInfo from './OrdersInfo/OrdersInfo';
import styles from './OrdersItem.module.scss';

const OrdersItem = ({ order }) => {
  const [showOrderInfo, setShowOrderInfo] = useState(false);
  const { orderNo, firstName, lastName, status, _id: id, date } = order;
  const [specifyOrderState, setspecifyOrderState] = useState(status);

  // useEffect(() => {
  //   setspecifyOrderState(statusChangeble === 'specified');
  // }, [statusChangeble]);
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <div>
            Замовлення № <span className={styles.bold}>{orderNo}</span>, {getDate(date)}
          </div>
          <div>
            Замовник:{' '}
            <span className={styles.bold}>
              {firstName}&nbsp;{lastName}
            </span>
          </div>
          <div>
            Сума: <span className={styles.bold}>
              {replace(typeof order.totalSum === 'object' ? order.totalSum.$numberDecimal : order.totalSum)} грн
            </span>
          </div>
        </div>
        <Status setspecifyOrderState={setspecifyOrderState} status={specifyOrderState} id={id} />
      </div>
      <div className={styles.infoBlock}>
        <div className={styles.infoOrderBtn}>
          {showOrderInfo ? (
            <div onClick={() => setShowOrderInfo(false)}>&uArr; Закрити інформацію&uArr;</div>
          ) : (
            <div onClick={() => setShowOrderInfo(true)}>&dArr; Вікрити інформацію &dArr;</div>
          )}
        </div>
        {showOrderInfo && <OrdersInfo order={order} OrderState={specifyOrderState}/>}
      </div>
    </div>
  );
};

OrdersItem.propTypes = {
  order: PropTypes.object.isRequired,
};

export default OrdersItem;
